// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"eG","carousel__wrapper_on_sides":"fG","arrows_wrapper":"gG","arrows_wrapper_right":"hG","arrows_wrapper_vertical":"iG","arrows_wrapper_on_sides":"jG","arrow_button":"kG","carousel_arrow_left":"lG","carousel_arrow_left_on_side":"mG","carousel_arrow_right_on_side":"nG","carousel_arrow":"oG","arrows_wrapper_rounded":"pG","carousel__fullWidth":"qG"};
    if(module.hot) {
      // 1730991508096
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  